import React from "react"
import { Marker } from "./dropdown-marker-elements"

const DropdownMarker = () => {
  return <Marker>▼</Marker>
}

export { DropdownMarker }
